import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Monaco: Country = {
    identifier: "Monaco",
    name: "Monaco",
    countryCode: "MC",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇲🇨",
    svgPath: "m 495.77175,326.8484 -0.171,0.073 0.007,-0.084 0.042,-0.046 0.054,-0.022 0.063,0.037 z",
}
